export const sum = (total: number, current: number | null | undefined) => total + (current ?? 0);
